import { render, staticRenderFns } from "./AnalystReview.vue?vue&type=template&id=cff2cbb8&scoped=true&"
import script from "./AnalystReview.vue?vue&type=script&lang=js&"
export * from "./AnalystReview.vue?vue&type=script&lang=js&"
import style0 from "./AnalystReview.vue?vue&type=style&index=0&id=cff2cbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2cbb8",
  null
  
)

export default component.exports